import React, { HTMLAttributes } from 'react';
import Immutable from 'immutable';
import {
  Container,
  WysiwygField,
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';


import './style.scss';
import classNames from 'classnames';
import { ParagraphUSP as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphUSPProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphUSP: React.FC<ParagraphUSPProps> = ({
  entity,
}) => {
  const paragraphUSP = entity.toJS();

  const title = paragraphUSP.field_title[0]?.value;
  const body = paragraphUSP.field_body[0].processed;
  const paragraphs = paragraphUSP.field_paragraphs;
  const linkTitle = paragraphUSP.field_link[0]?.title;
  const linkUri = paragraphUSP.field_link[0]?.alias || paragraphUSP.field_link[0]?.uri;
  const secondaryLink = paragraphUSP.field_link_secondary[0];
  const secondaryLinkTitle = secondaryLink?.title;
  const secondaryLinkUri = secondaryLink?.alias || secondaryLink?.uri;

  const subparagraphsClasses = classNames('ParagraphUSP__subparagraphs', {
    'ParagraphUSP__subparagraphs--two': paragraphs.length as Number === 2,
    'ParagraphUSP__subparagraphs--four': paragraphs.length as Number === 4,
  });

  return (
    <div className="Paragraph ParagraphUSP">
      <Container>
        <div className="ParagraphUSP__wrapper">
          <div className="row">
            <div className="col-12 col-lg-8 col-xl-7">
              <h2>{title}</h2>
              <WysiwygField html={body} />
            </div>
          </div>

          {paragraphs.length > 0 ? (
            <div className={subparagraphsClasses}>
              {paragraphs.map((paragraph) => {
                const id = paragraph.target_id;

                return (
                  <Paragraph
                    key={`paragraph:${id}`}
                    entity={Immutable.fromJS(paragraph.entity)}
                  />
                );
              })}
            </div>
          ) : null}

          {(linkUri || secondaryLinkUri) && (
            <div className="ParagraphUSP__buttons Text__links">
              {linkUri ? (
                <Button href={linkUri} className="Button--primary icon-after icon-arrow-right icon-variant-1" primary={false}>
                  <span>{linkTitle}</span>
                </Button>
              ) : null}
              {secondaryLinkUri ? (
                <Button href={secondaryLinkUri} className="Button--textual icon-after icon-arrow-right" primary={false}>
                  <span>{secondaryLinkTitle}</span>
                </Button>
              ) : null}
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default ParagraphUSP;
